import { MessageType } from 'antd/lib/message';
import { t } from 'helpers/i18n';
import { NotificationDescription, NotificationType } from 'store/notification/util';
import { notification } from 'antd';
import { NotificationInstance } from 'antd/lib/notification';

class NotificationHelper {
    private notificationInstance?: NotificationInstance;
    hidePopupFunc?: MessageType;

    setNotification(notification: NotificationInstance) {
        this.notificationInstance = notification;
    }

    showNotification(desc: NotificationDescription) {
        if (!this.notificationInstance) return;
        if (desc.visible) {
            switch (desc.notificationType) {
                case NotificationType.Success:
                    this.notificationInstance.success({
                        message: desc.message ? desc.message : t('Success'),
                        description: desc.description,
                        duration: desc.duration,
                        placement: desc.placement
                    });
                    break;
                case NotificationType.Error:
                    this.notificationInstance.error({
                        message: desc.message ? desc.message : t('Error'),
                        description: desc.description,
                        duration: desc.duration,
                        placement: desc.placement
                    });
                    break;
                case NotificationType.Warning:
                    this.notificationInstance.warning({
                        message: desc.message ? desc.message : t('Warning'),
                        description: desc.description,
                        duration: desc.duration,
                        placement: desc.placement
                    });
                    break;
                case NotificationType.Info:
                    this.notificationInstance.info({
                        message: desc.message ? desc.message : t('Information'),
                        description: desc.description,
                        duration: desc.duration,
                        placement: desc.placement
                    });
                    break;
                default:
                    return;
            }
        } else {
            notification.destroy();
        }
    }
}

export default new NotificationHelper();
